import { render } from "./page-autopayment.vue?vue&type=template&id=a10c9f84&scoped=true"
import script from "./page-autopayment.vue?vue&type=script&lang=js"
export * from "./page-autopayment.vue?vue&type=script&lang=js"

import "./page-autopayment.vue?vue&type=style&index=0&id=a10c9f84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10c9f84"]])

export default __exports__